import React, { useState } from 'react';
import GraduationTopHeader from '@/pages/graduation-management/components/GraduationTopHeader';
import GraduationFormSearch from '@/pages/graduation-management/components/GraduationFormSearch';
import GraduationList from '@/pages/graduation-management/components/GraduationList';

const GraduationManagementPage: React.FC = () => {
  const [uploadCsv, setUploadCsv] = useState('');
  const [searchTrigger, setSearchTrigger] = useState(0);

  return (
    <>
      <GraduationTopHeader setUploadCsv={setUploadCsv} />
      <GraduationFormSearch
        onSearch={() => setSearchTrigger((prev) => prev + 1)}
      />
      <GraduationList uploadCsv={uploadCsv} searchTrigger={searchTrigger} />
    </>
  );
};

export default GraduationManagementPage;
